import "./sw-menu.module.css";
import { html } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html.js";
import { LANGUAGE, DATE, isApple } from "../../global.ts";
import Strings from "../../../models/Strings.json";
import Bedok from "../../../models/Bedok.json";
//import LOTUS from "../../../public/lotus.webp";

const SW = new URL("../../../public/siliconwat.svg", import.meta.url).href;
const BUDDHA = new URL("../../../public/buddha.png", import.meta.url).href;

function groupBooks() {
    let groupedBooks = [];
    let startIndex = 0;

    Bedok["khmer"].baskets.forEach((count) => {
        groupedBooks.push({
            startIndex,
            books: Bedok["khmer"].books.slice(startIndex, ++count)
        });
        startIndex = count;
    });

    return groupedBooks;
}

// TODO: hide
function downloadBook(event, book) {
    event.preventDefault();
    window.open(Bedok["khmer"].pdfs[book], "_blank");
}

export default html`
    <div
        id="sw-menu"
        class="h-screen md:h-full w-70 md:w-100 lg:w-120 fixed top-0 left-0 z-50 p-4 overflow-hidden transition-transform -translate-x-full bg-white dark:bg-gray-800"
        tabindex="-1"
        aria-labelledby="sw-menu-label">
        <a
            href="#heartbank"
            onclick="heartbank.alertAdmin('menu/click/title')"
            id="sw-menu-label"
            class="moul self-center text-xl font-semibold whitespace-nowrap text-theme">
            <!--<svg
                class="inline w-8 h-8 fill-theme"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512">
                <path
                    d="M120 0c13.3 0 24 10.7 24 24l0 8 40 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 48 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 40 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 0 32 0 64c17.7 0 32 14.3 32 32l0 64c17.7 0 32 14.3 32 32l0 96c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-64 0 0-160-32 0 0-128-32 0 0-96-32 0 0 96 32 0 0 128 32 0 0 160-80 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 48-80 0 0-160 32 0 0-128 32 0 0-96-32 0 0 96-32 0 0 128-32 0 0 160-64 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l0-96c0-17.7 14.3-32 32-32l0-64c0-17.7 14.3-32 32-32l0-64 0-32 0-8c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-32-80l0 32 64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32z" />
            </svg>-->
            <img src="${SW}" width="50" height="50" class="inline mt-[-10px]" />
            <span class="ml-3">Silicon Wat</span>
            <!--Heart
            <svg
                class="mt-[-3px] ml-[-10px] mr-[-6px] inline fill-hb"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="30"
                height="30">
                <path
                    d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                    transform="rotate(45 12 12)" />
            </svg>
            ank<sup>®</sup>-->
        </a>
        <button
            title="${Strings.close[LANGUAGE]}"
            id="sw-menu-hide"
            type="button"
            data-drawer-hide="sw-menu"
            aria-controls="sw-menu"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white">
            <svg
                class="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14">
                <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
            </svg>
            <span class="sr-only">${Strings.close[LANGUAGE]}</span>
        </button>
        <div
            class="h-full py-4 mt-3 font-medium text-xs md:text-sm overflow-y-auto overflow-x-hidden flex flex-col items-left justify-between">
            <ul class="space-y-2">
                <li class="opacity-100">
                    <a
                        onclick="heartbank.alertAdmin('menu/click/notifications')"
                        id="sw-menu-notifications"
                        href2="#/notifications"
                        class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                        <svg
                            class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="skyblue"
                            viewBox="0 0 448 512">
                            <path
                                d="M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z" />
                        </svg>
                        <span
                            class="text-base moul flex-1 ms-3 whitespace-nowrap">
                            ${Strings.notifications[LANGUAGE]}
                        </span>
                        <span
                            class="inline-flex font-[arial] items-center justify-center w-3 h-3 p-3 ms-3 text-sm font-medium text-yellow-800 bg-yellow-100 rounded-full dark:bg-yellow-900 dark:text-yellow-300">
                            0
                        </span>
                    </a>
                </li>
                ${groupBooks().map(
                    (group, basket) => html`
                        <li class="${Strings.baskets["colors"][basket]}">
                            <button
                                id="sw-menu-basketBtn-${basket}"
                                type="button"
                                onclick="heartbank.alertAdmin('menu/click/basket/${Strings
                                    .baskets[LANGUAGE][basket]}')"
                                class="flex items-center w-full p-2 text-base transition duration-75 rounded-lg group hover:bg-gray-100 dark:hover:bg-gray-700"
                                aria-controls="sw-menu-basket-${basket}"
                                data-collapse-toggle="sw-menu-basket-${basket}">
                                <svg
                                    class="${Strings.baskets["colors2"][
                                        basket
                                    ]} flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="14"
                                    width="12.25"
                                    viewBox="0 0 448 512">
                                    <path
                                        d="M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
                                </svg>
                                <span
                                    class="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap"
                                    >${Strings.baskets[LANGUAGE][basket]}</span
                                >
                                <svg
                                    class="w-3 h-3 text-gray-500 dark:text-gray-400"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 10 6">
                                    <path
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="m1 1 4 4 4-4" />
                                </svg>
                            </button>
                            <ul
                                id="sw-menu-basket-${basket}"
                                class="hidden py-2 space-y-2">
                                ${group.books.map(
                                    (pages, book) => html`
                                        <li
                                            @contextmenu=${(event) =>
                                                downloadBook(
                                                    event,
                                                    group.startIndex + book
                                                )}>
                                            <div
                                                class="text-sm flex items-center w-full p-2 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100 dark:hover:bg-gray-700">
                                                <a
                                                    onclick="heartbank.alertAdmin('menu/click/${Strings
                                                        .book[
                                                        LANGUAGE
                                                    ]}/${group.startIndex +
                                                    book +
                                                    1}')"
                                                    href="#/book/${group.startIndex +
                                                    book +
                                                    1}">
                                                    ${Strings.book[LANGUAGE]}
                                                    <span
                                                        class="ms-2 bg-blue-100 text-blue-800 me-2 px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
                                                        ${(
                                                            group.startIndex +
                                                            book +
                                                            1
                                                        ).toKhmer(LANGUAGE)}
                                                    </span>
                                                </a>
                                                <button
                                                    class="ml-24"
                                                    title="${Strings.download[
                                                        LANGUAGE
                                                    ]}"
                                                    onclick="heartbank.alertAdmin('menu/click/download/${group.startIndex +
                                                    book +
                                                    1}');alert('${Strings.soon[
                                                        LANGUAGE
                                                    ]}')">
                                                    <svg
                                                        class="w-5 h-5 fill-gray-700 dark:fill-gray-400"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 448 512">
                                                        <path
                                                            d="M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7 256 32zM64 320c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-46.9 0-56.6 56.6c-31.2 31.2-81.9 31.2-113.1 0L110.9 320 64 320zm304 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </li>
                                    `
                                )}
                            </ul>
                        </li>
                    `
                )}
            </ul>
            <ul class="moul text-white my-10 px-5">
                <li class="">
                    <a
                        href="#readership"
                        onclick="heartbank.alertAdmin('menu/click/readership')"
                        class="w-60 bg-teal-500 hover:bg-teal-500/80 focus:ring-4 focus:outline-none focus:ring-teal-500/50 font-medium rounded-lg text-base px-5 py-2.5 inline-flex items-center justify-center dark:hover:bg-teal-500/80 dark:focus:ring-teal-500/40 me-5">
                        <svg
                            class="me-4 w-6 h-6 mt-0 ml-[-10px]"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            fill="currentColor">
                            <path
                                d="M256 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm96 312c0 25-12.7 47-32 59.9l0 92.1c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-92.1C172.7 359 160 337 160 312l0-40c0-53 43-96 96-96s96 43 96 96l0 40zM96 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm16 240l0 32c0 32.5 12.1 62.1 32 84.7l0 75.3c0 1.2 0 2.5 .1 3.7-8.5 7.6-19.7 12.3-32.1 12.3l-32 0c-26.5 0-48-21.5-48-48l0-56.6C12.9 364.4 0 343.7 0 320l0-32c0-53 43-96 96-96 12.7 0 24.8 2.5 35.9 6.9-12.6 21.4-19.9 46.4-19.9 73.1zM368 464l0-75.3c19.9-22.5 32-52.2 32-84.7l0-32c0-26.7-7.3-51.6-19.9-73.1 11.1-4.5 23.2-6.9 35.9-6.9 53 0 96 43 96 96l0 32c0 23.7-12.9 44.4-32 55.4l0 56.6c0 26.5-21.5 48-48 48l-32 0c-12.3 0-23.6-4.6-32.1-12.3 0-1.2 .1-2.5 .1-3.7zM416 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112z" />
                        </svg>
                        ${Strings.map[LANGUAGE]}
                    </a>
                </li>
                <li class="cursor-pointer">
                    <img
                        id="sw-menu-monk"
                        onclick="heartbank.alertAdmin('menu/click/robot-monk')"
                        src="${BUDDHA}"
                        alt="robot monk"
                        class="w-60 my-5 rounded-lg" />
                </li>
                <li class="">
                    <button
                        id="sw-menu-donate"
                        onclick="heartbank.alertAdmin('menu/click/thank')"
                        type="button"
                        data-modal-show="sw-feedback"
                        class="${LANGUAGE === "khmer"
                            ? "text-[11px]"
                            : "text-xs"} w-60 bg-hb hover:bg-hb/80 focus:ring-4 focus:outline-none focus:ring-hb/50 font-medium rounded-lg px-5 py-2.5 inline-flex items-center justify-center dark:hover:bg-hb/80 dark:focus:ring-hb/40 me-5">
                        <svg
                            class="${LANGUAGE === "khmer"
                                ? "me-2"
                                : "me-3"} w-6 h-6 mt-0 ml-[-10px]"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor">
                            <path
                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                transform="rotate(45 12 12)" />
                        </svg>
                        ${unsafeHTML(Strings.donate[LANGUAGE])}
                    </button>
                </li>
                <li
                    class="hidden"
                    data-modal-target="sw-donate"
                    data-modal-show="sw-donate"></li>
            </ul>
            <ul class="my-2">
                <li class="moul">
                    <a
                        id="sw-menu-youtube"
                        onclick="heartbank.alertAdmin('menu/click/youtube')"
                        href="https://www.facebook.com/siliconwat"
                        href2="https://www.youtube.com/@SiliconWat"
                        target="_blank"
                        class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                        <svg
                            class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="red"
                            height="14"
                            width="10.5"
                            viewBox="0 0 576 512">
                            <path
                                d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" />
                        </svg>
                        <span
                            class="${LANGUAGE === "khmer"
                                ? "text-xs md:text-sm"
                                : "text-base md:text-base"} flex-1 ms-3 whitespace-nowrap"
                            >${Strings.youtube[LANGUAGE]}</span
                        >
                    </a>
                </li>
                <li class="moul">
                    <a
                        target="_blank"
                        onclick="heartbank.alertAdmin('menu/click/install-silicon-wat');alert('${Strings
                            .soon[LANGUAGE]}')"
                        href2="#333"
                        href3="https://gemini.google.com"
                        href="https://siliconwat.com"
                        class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                        <svg
                            class="fill-green-500 flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill2="green"
                            height="14"
                            width="10.5"
                            viewBox="0 0 384 512">
                            <path
                                d="M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64L80 64l0 320 224 0 0-320z" />
                        </svg>
                        <span
                            class="text-base text-gray-700 dark:text-gray-300 flex-1 ms-3 whitespace-nowrap"
                            >${unsafeHTML(Strings.sw[LANGUAGE])}</span
                        >
                    </a>
                </li>
                <li class="moul">
                    <a
                        href2="#ai"
                        href3="${isApple
                            ? "https://translate.google.com/?sl=${Strings.language[LANGUAGE]}&tl=en&op=translate"
                            : "https://grok.com"}"
                        href4="https://grok.com"
                        href="https://siliconwat.org"
                        target="_blank"
                        onclick="heartbank.alertAdmin('menu/click/install-buddha-ai');alert('${Strings
                            .soon[LANGUAGE]}')"
                        class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                        <svg
                            class="fill-green-500 flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill2="green"
                            height="14"
                            width="10.5"
                            viewBox="0 0 384 512">
                            <path
                                d="M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64L80 64l0 320 224 0 0-320z" />
                        </svg>
                        <span
                            class="text-base text-gray-700 dark:text-gray-300 flex-1 ms-3 whitespace-nowrap"
                            >${unsafeHTML(Strings.ai[LANGUAGE])}</span
                        >
                    </a>
                </li>
                <li class="moul">
                    <a
                        target="_blank"
                        onclick="heartbank.alertAdmin('menu/click/join-ai-board')"
                        href="https://www.facebook.com/siliconwat"
                        class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                        <svg
                            class="fill-orange-600 flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill2="orangered"
                            height="14"
                            width="10.5"
                            viewBox="0 0 512 512">
                            <path
                                d="M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10.1 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.6 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.6-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                        </svg>
                        <span
                            class="text-base text-gray-700 dark:text-gray-300 flex-1 ms-3 whitespace-nowrap">
                            ${unsafeHTML(Strings.join[LANGUAGE])}
                        </span>
                    </a>
                </li>
                <li class="moul mb-3 mt-8">
                    <a
                        href="https://thonly.org"
                        onclick="heartbank.alertAdmin('menu/click/thonly')"
                        target="_blank"
                        class="text-sm text-gray-500 dark:text-gray-400"
                        >THonly™ © USA 2025</a
                    >
                </li>
                <li class="mb-9">
                    <a
                        id="sw-menu-reset"
                        onclick="heartbank.alertAdmin('menu/click/reset')"
                        class="text-xs cursor-pointer font-thin text-gray-500 dark:text-gray-400">
                        ${Strings.updated[LANGUAGE]} ${DATE.formatDate()}
                    </a>
                </li>
            </ul>
        </div>
    </div>
`;
